import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { AccountCategory, Module, useAddAccountMutation, useUpdateAccountMutation, useGetUserQuery } from '~/types/types';
import { usageTypes, modules } from '~/assets/helper/functions';
export default /*#__PURE__*/_defineComponent({
  __name: 'EditAccount',
  props: {
    item: {
      type: Object
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var moduleOptions = computed(function () {
      var _account$value;
      if (((_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.type) === AccountCategory.Venture) {
        return modules.filter(function (item) {
          return item.value !== Module.Review;
        });
      }
      return modules.filter(function (item) {
        return item.value !== Module.CompanyInfo;
      });
    });
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    var _useAddAccountMutatio = useAddAccountMutation(),
      addAccount = _useAddAccountMutatio.mutate;
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate,
      onUpdateDone = _useUpdateAccountMuta.onDone;
    onUpdateDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var account = ref(_objectSpread({}, props.item));
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var editTitle = computed(function () {
      return account.value && account.value.id ? proxy.$t('titleEdit') : proxy.$t('titleCreate');
    });
    var password = ref('');
    var email = ref('');
    return {
      __sfc: true,
      props: props,
      moduleOptions: moduleOptions,
      userResult: userResult,
      user: user,
      addAccount: addAccount,
      updateAccount: updateAccount,
      onUpdateDone: onUpdateDone,
      account: account,
      proxy: proxy,
      editTitle: editTitle,
      password: password,
      email: email,
      AccountCategory: AccountCategory,
      usageTypes: usageTypes,
      modules: modules
    };
  }
});